import * as moment from 'moment';

import { Goal } from './goal.model';
import { Card } from './card.model';
import { PlayerStatistic } from './player-statistic.model';
import { Transfer } from './transfer.model';
import { Injury } from './injury.model';
import { Penalty } from './penalty.model';
import { LivePlayerStatistic } from './live-player-statistic.model';
import { Subscription } from 'rxjs/Subscription';
import {SizeReceiver} from './size-receiver.model';
import {Trophie} from './trophie.model';

export class Player implements SizeReceiver{
    id: number;
    number: number;
    country: string;
    description: string;
    position: string;
    birthDate: moment.Moment;
    birthDay: number;
    birthMonth: number;
    birthYear: number;
    firstName: string;
    lastName: string;
    nationality: string;
    nationalMatches: number = 0;
    nationalGoals: number = 0;
    birthCountry: string;
    weight: string;
    teamId: number;
    teamName: string;
    birthPlace: string;
    isCaptain: boolean = false;
    playerId: number;
    age: number;
    name: string;
    shortFirstName: string;
    shortLastName: string;
    height: string;
    x: number = 5;
    y: number = 50;
    pitchWidth: number = 0;
    pitchHeight: number = 0;
    bench: boolean = false;
    goals: Goal[] = [];
    seasonGoals: number;
    cards: Card[] = [];
    keyfacts: string = '';
    playerStatistic: PlayerStatistic = new PlayerStatistic();
    playerStatisticLoaded: boolean = false;
    livePlayerStatistic: LivePlayerStatistic = new LivePlayerStatistic();
    livePlayerStatisticSubscription: Subscription;
    transfers: Transfer[] = [];
    transfersLoaded: boolean = false;
    injuries: Injury[] = [];
    injuriesLoaded: boolean = false;
    trophies: Trophie[] = [];
    penalties: Penalty[] = [];
    clientWidth: number;
    clientHeight: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/player.model.ts